import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Angular = () => {
  return (
    <StartInterviewLayout type="angular"/>
  )
}

export default Angular;